export function getLocale(): string {
  // `navigator` is browser-only and, in Node, only exists from v21.2.0
  // onward (when `navigator.language` was added). CI/SSR can run on an
  // older Node, where this would otherwise throw.
  if (typeof navigator === "undefined" || !navigator.language) {
    return "en-US";
  }
  return navigator.language;
}

export function getLocaleLanguage(): string {
  const locale = getLocale();
  let language = "en";

  if (locale.includes("-")) {
    language = locale.split("-").shift() || language;
  }

  return language;
}

export function getLocaleCountryCode(): string {
  const locale = getLocale();
  let countryCode = "US";

  if (locale.includes("-")) {
    countryCode = locale.split("-").pop() || countryCode;
  }

  return countryCode;
}

export function getLocaleCountry(): string | undefined {
  const language = getLocaleLanguage();
  const regions = new Intl.DisplayNames(["en"], { type: "region" });
  const country = regions.of(language);
  return country;
}
